import { Box, Card, CardContent, IconButton, Typography } from '@mui/material';
import styles from './CRMCard.module.scss';
import classNames from 'classnames/bind';
import { CallIcon, SendMailIcon } from '~/assets/icons';
import { useTranslation } from 'react-i18next';
import { ICRMBoard } from '~/utils/interface/customer';
import { BaseImage } from '~/components/common';
import { memo } from 'react';
import usePermission from '~/hooks/usePermission';
import { PERMISSIONS } from '~/utils/constants/permission';

interface Props {
  crm: ICRMBoard;
  onCall: (phone: string) => void;
  onMessage: (phone: string) => void;
}

function CRMCard({ crm, onCall, onMessage }: Props) {
  const { t } = useTranslation('admin/customer');
  const cx = classNames.bind(styles);
  const permissions = usePermission();

  const handlePhoneCallClick = (phone?: string) => {
    phone && onCall && onCall(phone);
  };

  const handleMessageClick = (phone?: string) => {
    phone && onMessage && onMessage(phone);
  };
  return (
    <Card className={cx('container-card')}>
      <CardContent className='!p-[16px]'>
        <Box className={cx('card-content')}>
          <Box className='flex'>
            <BaseImage src={crm?.avatar} className={cx('image')} />
            <Typography variant='h6' className={cx('card-content-title', 'truncate')}>
              {crm.fullName}
            </Typography>
          </Box>
          <Box className={cx('icon-buttons')}>
            {permissions[PERMISSIONS.crm_call] && (
              <IconButton
                disabled={!crm.phone}
                onClick={() => handlePhoneCallClick(crm.phone)}
                className={cx('icon-container')}
              >
                <CallIcon className={cx('icon')} />
              </IconButton>
            )}
            {permissions[PERMISSIONS.crm_message] && (
              <IconButton
                disabled={!crm.phone}
                onClick={() => handleMessageClick(crm.phone)}
                className={cx('icon-container')}
              >
                <SendMailIcon className={cx('icon')} />
              </IconButton>
            )}
          </Box>
        </Box>

        <Box className={cx('border')}></Box>
        <Box className={cx('info-container')}>
          <Box className={cx('type-container')}>
            <Box>
              <Typography className={cx('type-label')}>{t('properties.category')}</Typography>
            </Box>
            <Box>
              <Typography className={cx('type-title')}>{crm?.category}</Typography>
            </Box>
          </Box>

          <Box className={cx('type-container')}>
            <Box>
              <Typography className={cx('type-label')}>{t('properties.address')}</Typography>
            </Box>
            <Typography className={cx('type-title', 'line-clamp-2')}>{crm?.fullAddress}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default memo(CRMCard);
